var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.333344C3.324 0.333344 0.333332 3.32401 0.333332 7.00001C0.333332 10.676 3.324 13.6667 7 13.6667C10.676 13.6667 13.6667 10.676 13.6667 7.00001C13.6667 3.32401 10.676 0.333344 7 0.333344ZM7 2.38601V6.33334C7 6.70134 6.70133 7.00001 6.33333 7.00001H2.386C1.982 7.00001 1.66333 6.64201 1.72067 6.24201C2.054 3.90668 3.90667 2.05401 6.242 1.72068C6.642 1.66334 7 1.98201 7 2.38601Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.60154e91a8a9ae6282277fe4ad0cb559.svg";
export { ForwardRef as ReactComponent };